import { useContext } from 'react';

import { DeleteGoalsContext } from './delete-goals-context';

export const useOpenDeleteGoalsDialog = () => {
  const { onDeleteGoals } = useContext(DeleteGoalsContext);
  return onDeleteGoals;
};
